import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class RefreshButtonComponent extends Component {
  @action
  refresh() {
    this.args.refreshAction();
  }
}
